const fragShader = require('./shaderHighlight.frag').default
const key = 'ShaderHighlightPipeline2'

export class ShaderHighlightPipeline2 extends Phaser.Renderer.WebGL.Pipelines
  .SinglePipeline {
  public static readonly KEY = key
  constructor(game: any) {
    super({
      game,
      name: key,
      fragShader,
      uniforms: ['uMainSampler', 'uTime', 'uResolution', 'uUvCenter'],
    } as any)
    console.log('SHADER', 'constructed shader', key)
  }

  onPreRender() {
    this.setTime('uTime')
    //this.set2f('uResolution', )
    // this.setTime('uTime')
    // this.set1f('uSpeed', this.speed)
    // if (common.hasScene()) {
    //   let gb = underCamera.getGameBounds()
    //   this.set2f('uResolution', gb.width, gb.height)
    // }
  }
}
